export enum EventRegistrationStatus {
  PASSED = "passed",
  QUALIFIED = "qualified",
  FAILED = "failed"
}

export enum EventRegistrationAdditionalStatus {
  CHEATING = "cheating",
  EXCUSED = "excused",
  NO_CARD = "no_card",
  NO_SHOW = "no_show",
  POOR_CONDUCT = "poor_conduct",
  WEATHER_EVENT = "weather_event",
  WITHDRAWAL = "withdrawal",
  MEDICAL_WITHDRAWAL = "medical_withdrawal",
  DISQUALIFIED = "disqualified"
}

export interface EventRegistrant {
  id: string;
  pgaId: string;
  profilePhoto: string;
  programType: string;
  gender: string;
  age: number;
  registrantName: string;
  attended: boolean | null;
  status: string;
  customFields: {
    gender: string;
    date_of_birth: string;
  };
  sessionRegistrations: {
    id: string;
    attended: boolean;
  }[];
  patSubmission: {
    roundOne: {
      roundScore: string;
      meetsQualifyingScore: boolean;
    };
    roundTwo: {
      roundScore: string;
      meetsQualifyingScore: boolean;
    };
    targetScore: number;
    totalScore: number;
    result: EventRegistrationStatus;
    additionalStatus: string;
    note: string;
    date: string;
    suspension: {
      startDate: string;
      endDate: string;
    } | null;
    document: {
      id: string;
      url: string;
      name: string;
    } | null;
  };
}

export interface RegistrantRow {
  id: string;
  pgaId: string;
  profilePhoto: string;
  programType: string;
  gender: string | null;
  age: number | null;
  registrantName: string;
  attended: boolean | null;
  score_18_1: string | "";
  meets_qualifying_score_18_1: boolean;
  score_18_2: string | "";
  meets_qualifying_score_18_2: boolean;
  score_target: number | null;
  score_total: number | null;
  status: string;
  sessionRegistrationId: string;
  additionalStatus: string;
  note: string;
  date: string;
  suspension: {
    startDate: string;
    endDate: string;
  } | null;
  document: {
    id: string;
    url: string;
    name: string;
  } | null;
  documentUrl: string | null;
  hasDocument: boolean;
}

export interface EventRegistrantNode {
  node: EventRegistrant;
}

export interface EventRegistrants {
  eventRegistrants: {
    edges: EventRegistrantNode[];
    totalCount: number;
    pageInfo: {
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      startCursor?: string;
      endCursor?: string;
    };
  };
}

export interface StatusCounts {
  invalidCount: number;
  passingCount: number;
  qualifyingCount: number;
  failingCount: number;
  cheatingCount: number;
  excessiveCount: number;
  noCardCount: number;
  noShowCount: number;
  poorConductCount: number;
  weatherEventCount: number;
  withdrawalCount: number;
  excusedCount: number;
  medicalWithdrawalCount: number;
  disqualifiedCount: number;
  missingStatusCount: number;
}

export interface Status {
  status: string;
}

export enum RegistrationStatus {
  ALL = "ALL",
  CANCELED = "CANCELED",
  REGISTERED = "REGISTERED"
}

export interface Variables {
  eventSlug?: string;
  search?: string;
  first?: number;
  last?: number;
  after?: string;
  before?: string;
  status?: RegistrationStatus;
}

export interface PATMetricType {
  label: string;
  value: string | number;
  onEdit?: (newValue: string) => void;
}
